import { TruckSize, TruckSizeUnion, TruckStatus } from '../../../../../../common/constants';
import { TruckLoadingType } from '../../../../administration';

export class AllocationCalendarTruckInfo {
  truckId: number;
  carrierExtId: string;
  carrierName: string;
  carrierNumber: string;
  freeTextCarrierName: string;
  truckPlateId: string;
  truckPlateIdCountryOfOrigin: string;
  trailerPlateId: string;
  trailerPlateIdCountryOfOrigin: string;
  truckSize: TruckSizeUnion = TruckSize.L;
  truckLoadingTypes: TruckLoadingType[] = [TruckLoadingType.End];
  status: TruckStatus;
}
